import PropTypes from "prop-types";
import React, { useEffect, useContext } from "react";
import { useParams } from "react-router-dom";

import { Grid } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import HorizontalNav from "../Navigation/HorizontalNav";
import VerticalNav from "../Navigation/VerticalNav";
import { FleetContext } from "../../context";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: theme.spacing(3, 0, 3, theme.navSpacingSize),
  },
  wrapperMobile: {
    padding: theme.spacing(3 + theme.navSpacingSize, 0, 3, 0),
  },
}));

const PageLayout = ({ children }) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { activeFleet, fleets, setActiveFleet, fetchFleets } = useContext(FleetContext);
  const { fleetId } = useParams();

  useEffect(() => {
    if (!fleets.length) {
      fetchFleets();
    }
    if (fleetId && activeFleet.uuid4 !== fleetId) {
      setActiveFleet(fleetId);
    }
  }, []);

  return (
    <>
      {isMobile ? <HorizontalNav /> : <VerticalNav />}
      <Grid
        component="main"
        container
        direction="row"
        justify="center"
        alignItems="flex-start"
        className={isMobile ? classes.wrapperMobile : classes.wrapper}
      >
        <Grid item xl={9} lg={11} md={11} xs={12}>
          {children}
        </Grid>
      </Grid>
    </>
  );
};

PageLayout.propTypes = {
  children: PropTypes.element.isRequired,
};

export default PageLayout;
